import React from 'react';
import Modal from '../../../components/Modal/Modal';
import Button from '../../../components/Button/Button';
import './ProductReplaceModal.css';

function ProductReplaceModal({acceptLabel, rejectLabel, onSelect, onClose}) {
    const handleAccept = () => {
        if (onSelect) onSelect(true);
        handleClose();
    };

    const handleReject = () => {
        if (onSelect) onSelect(false);
        handleClose();
    };

    const handleClose = () => {
        if (onClose) onClose();
    };

    return (
        <Modal title='¿Deseas reemplazar el producto anterior con este producto?' showCloseButton={false} onClose={handleClose}>
            <div className='product-replace-modal'>
                <div className='product-replace-modal_description'>Sólo puedes mantener un producto en el carro de compras</div>
                <div className='product-replace-modal_buttons'>
                    <div className='product-replace-modal_button'>
                        <Button
                            icon={undefined}
                            label={acceptLabel}
                            labelColor='#FFFFFF'
                            backgroundColor='#002EFF'
                            borderColor='#002EFF'
                            borderWidth={0}
                            borderRadius={50}
                            padding='15px 10px'
                            paddingTarget='label'
                            margin={0}
                            width='100%'
                            minWidth={undefined}
                            maxWidth={undefined}
                            height='auto'
                            minHeight={undefined}
                            maxHeight={undefined}
                            transition='label'
                            fontSize={14}
                            boxShadow='unset'
                            isLoading={false}
                            loadLabel={undefined}
                            disabled={false}
                            showPulseEffect={false}
                            notificationNumber={undefined}
                            notificationBackgroundColor={undefined}
                            notificationLabelColor={undefined}
                            onClick={handleAccept}
                        />
                    </div>
                    <div className='product-replace-modal_button'>
                        <Button
                            icon={undefined}
                            label={rejectLabel}
                            labelColor='#002EFF'
                            backgroundColor='#FFFFFF'
                            borderColor='#002EFF'
                            borderWidth={0}
                            borderRadius={50}
                            padding='15px 10px'
                            paddingTarget='label'
                            margin={0}
                            width='100%'
                            minWidth={undefined}
                            maxWidth={undefined}
                            height='auto'
                            minHeight={undefined}
                            maxHeight={undefined}
                            transition='label'
                            fontSize={14}
                            boxShadow='unset'
                            isLoading={false}
                            loadLabel={undefined}
                            disabled={false}
                            showPulseEffect={false}
                            notificationNumber={undefined}
                            notificationBackgroundColor={undefined}
                            notificationLabelColor={undefined}
                            onClick={handleReject}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default ProductReplaceModal;